<template>
  <div class="page-container">
    <template v-if="true">
      <div class="page-container-body">
        <div class="d-flex align-center ga-2 mb-8">
          <span @click="goBack()" class="goBack">
            <v-icon>
              mds:arrow-back
            </v-icon>
          </span>
          <h3 class="page-title">Billing History</h3>
        </div>

        <div class="manage-billing-form">
          <v-data-table
            :loading="loadingInvoices"
            v-if="invoices"
            :headers="headersInvoices"
            :items="invoices"
            :items-per-page="-1"
            v-model:expanded="expanded"
            hover
            show-expand
          >
            <template v-slot:item.amountDue="{ item }">
              ${{ formatNumberWithDecimals(item.amountDue || 0) }}
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ item.createdAt ? format(new Date(item.createdAt * 1000), 'MMMM d, yyyy HH:mm') : '' }}
            </template>
            <template v-slot:item.status="{ item }">
              {{ item.status ? capitalizeFirstLetter(item.status) : '-' }}
            </template>
            <template v-slot:item.preview="{ item }">
              <a :href="item.hostedInvoiceUrl" target='_blank'>
                <v-icon>mdi-eye-outline</v-icon>
              </a>
            </template>
            <template v-slot:item.downloadPDF="{ item }">
              <a :href='item.invoicePdf' download='true'>
                <v-icon>mdi-download</v-icon>
              </a>
            </template>
            <template v-slot:expanded-row="{ item }">
              <template v-if="!!item.lines">
                <div class="d-flex flex-column ga-2" v-for="line in item.lines" :key="line.id">
                  <template v-if="!!line?.data?.length">
                    <p v-for="(item,index) in line.data" :key="index">
                      {{ item.description }}
                    </p>
                  </template>
                  <p v-else>No items</p>
                </div>
              </template>
              <template v-else>
                No data
              </template>
            </template>
          </v-data-table>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-loading-container-body">
        <v-progress-circular
          indeterminate
          color="white"
          size="32"
          width="2">
        </v-progress-circular>
        <span>Loading billing history...</span>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import format from 'date-fns/format'
import { capitalizeFirstLetter, formatNumberWithDecimals } from '@/helpers/formatting'

export default {
  computed: {
    ...mapState({
      currentUser: state => state.user.user,
      invoices: state => state.payments.invoices,
      loadingInvoices: state => state.payments.loadingInvoices
    })
  },
  methods: {
    format,
    capitalizeFirstLetter,
    formatNumberWithDecimals,
    goBack () {
      this.$router.push('/subscription/billing')
    }
  },
  data () {
    return {
      expanded: [],
      headersInvoices: [
        {
          title: 'Amount Due (USD)',
          sortable: true,
          key: 'amountDue'
        },
        {
          title: 'Creation Date',
          sortable: true,
          key: 'createdAt'
        },
        {
          title: 'Status',
          sortable: true,
          key: 'status'
        },
        {
          title: 'Preview',
          sortable: false,
          key: 'preview',
          align: 'center'
        },
        {
          title: 'Download PDF',
          sortable: false,
          key: 'downloadPDF',
          align: 'center'
        }
      ]
    }
  },
  mounted () {
    if (this.currentUser) {
      store.dispatch('payments/getInvoices', {
        limit: 100
      })
    }
  },
  watch: {
    currentUser: function (currentUser) {
      if (currentUser) {
        store.dispatch('payments/getInvoices', {
          limit: 100
        })
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.page-container-body {
  flex-grow: 1;
  padding: 0 4px;
  overflow: auto;
}

.page-loading-container-body {
  gap: 16px;
  height: 100%;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: var(--dark-4, #363A40);
}

.goBack {
  cursor: pointer;
  color: var(--dark-4, #363A40);
}

.page-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--dark-4, #363A40);
}

[data-theme="dark"] a {
  color: var(--blue-1);
}
</style>
